export default __webpack_public_path__ + "static/media/amatic.94415082.svg";